var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2m13.7167,6.94168l-5.892,5.892l-3.533,-3.534l1.175,-1.175l2.358,2.359l4.717,-4.717l1.175,1.175zm-11.383,2.058c0,-1.941,0.85,-3.683,2.183,-4.9l1.983,1.984v-5h-5l1.834,1.833c-1.634,1.517,-2.667,3.675,-2.667,6.083c0,4.325,3.292,7.875,7.5,8.292v-1.683c-3.283,-0.409,-5.833,-3.217,-5.833,-6.609zm15,0c0,-4.325,-3.292,-7.875,-7.5,-8.292v1.684c3.283,0.408,5.833,3.216,5.833,6.608c0,1.942,-0.85,3.683,-2.183,4.9l-1.983,-1.983v5h5l-1.834,-1.834c1.634,-1.516,2.667,-3.675,2.667,-6.083z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSvg);
export default __webpack_public_path__ + "static/media/ChangeSvg.26f90fe5.svg";
export { ForwardRef as ReactComponent };